import { EmailIcon } from '../../base'

function Email({email = null, show = true, color = 'pcolor'}) {
  return (
    <div className='contactOption d-flex gap-1' style={{ alignItems : 'center'}}> 
        <EmailIcon/> :
        {
           email && email.length > 5 ? <a href={`mailto:${email}`} className={`${color} option ms-1 h6`}>{email} </a> : <div className={`${color} option ms-1 h7`}>No Email Found</div>
        }
        {/* {
          show && email && email.length > 5 && <span className='h7'>( click to email )</span>
        } */}
    </div>
  )
}

export default Email